import { render, staticRenderFns } from "./TreatmentListItem.vue?vue&type=template&id=498163fe&scoped=true"
import script from "./TreatmentListItem.vue?vue&type=script&lang=js"
export * from "./TreatmentListItem.vue?vue&type=script&lang=js"
import style0 from "./TreatmentListItem.vue?vue&type=style&index=0&id=498163fe&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "498163fe",
  null
  
)

export default component.exports